import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
  name: 'noticeStatus'
})
export class NoticeStatusPipe implements PipeTransform {

  transform(item: any): string {
    const now = moment();
    const start = item.start_datetime ? moment(item.start_datetime) : null;
    const end = item.end_datetime ? moment(item.end_datetime) : null;

    if (start && now.isBefore(start)) {
      const diff = start.fromNow(); // e.g., "in 2 days"
      return `⏳ Pending – starts ${diff}`;
    }

    if (end && now.isAfter(end)) {
      const diff = end.fromNow(); // e.g., "3 hours ago"
      return `❌ Expired – ended ${diff}`;
    }

    if ((!start || now.isSameOrAfter(start)) && (!end || now.isSameOrBefore(end))) {
      const remaining = end ? end.fromNow() : 'ongoing';
      return `✅ Active Now – ends ${remaining}`;
    }

    return `❔ Unknown`;
  }
}